import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgpTooltip, NgpTooltipTrigger } from 'ng-primitives/tooltip';
import { ButtonDirective } from '../../primitives/button/button.directive';

@Component({
  selector: 'tc-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgpTooltip, NgpTooltipTrigger, ButtonDirective],
  template: `
    <button type="button" tcButton [ngpTooltipTrigger]="tooltip">
      <ng-content />
    </button>

    <ng-template #tooltip>
      <div ngpTooltip>{{ content() }}</div>
    </ng-template>
  `,
})
export class TooltipComponent {
  readonly content = input.required<string>();
}
